/**
 * Build a breadcrumb trail for a support article.
 * Exported for reuse by JSON-LD (phase 03) — compute once, consume in UI + SEO.
 *
 * Section crumbs are plain text only — section index pages do not exist.
 * URL-less items are shown in the UI but omitted from JSON-LD (see SEO.jsx).
 *
 * @returns {{ name: string, url?: string }[]}
 */
export const buildBreadcrumbTrail = ({ category, section, title, slug }) => {
  const trail = [{ name: 'Support', url: '/support/' }]

  if (category?.id && category?.title) {
    trail.push({
      name: category.title,
      url: `/support/${category.id}/`
    })
  }

  if (section?.title) {
    trail.push({ name: section.title })
  }

  if (title && slug) {
    trail.push({ name: title, url: slug })
  }

  return trail
}
